/* eslint react/jsx-filename-extension: 0 */
import React, { Component } from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { shape } from 'prop-types';

import getTranslatedNames from './components/getTranslatedNames';
import convertToArray from './components/convertToArray';
import Routes from './Routes';
import { withFirebase } from './components/Firebase';

const initialState = {
  ...Object.assign(window.pageData, {
    hasError: false,
    errorText: '',
    genres: [],
    loadingGenres: true,
    stations: [],
    loadingStations: true,
    currentlyPlaying: {},
    isPlaying: false,
    playerIsVisible: false,
    player: {},
    modalIsVisible: true,
  }),
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.playStation = this.playStation.bind(this);
    this.pauseStation = this.pauseStation.bind(this);
    this.closePlayer = this.closePlayer.bind(this);
    this.setPlayer = this.setPlayer.bind(this);
  }

  componentDidMount() {
    const { firebase } = this.props;
    const { genreNames } = this.state;
    firebase.genres().on('value', (snap) => {
      const genres = getTranslatedNames(convertToArray(snap.val()), genreNames);
      this.setState({
        genres,
        loadingGenres: false,
      });
      firebase.stations().on('value', (snapshot) => {
        const stations = convertToArray(snapshot.val());
        const sortedStations = stations
          .filter(station => station.active)
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        this.setState({
          stations: sortedStations,
          loadingStations: false,
        });
      });
    });
  }

  showModal = function displayModalWithCurrentStationInfo() {
    this.setState({ modalIsVisible: true });
  };

  hideModal = function hideModalFromDisplaying() {
    this.setState({ modalIsVisible: false });
  };

  playStation = function displayPlayerAndStartStream(station) {
    this.hideModal();
    this.setState({
      isPlaying: true,
      playerIsVisible: true,
      currentlyPlaying: station,
    });
    const { player, dataLayer } = this.state;
    if (player.isAudio) {
      player.pause();
      player.src(station.streams);
      player.load();
      player.play();
    }
    dataLayer.push({
      event: 'radio listen',
      eventCategory: station.name,
    });
  };

  pauseStation = function pauseStreamButKeepPlayer() {
    this.setState({ isPlaying: false });
    const { player } = this.state;
    player.pause();
  };

  closePlayer = function closeStationPlayer() {
    this.setState({
      isPlaying: false,
      playerIsVisible: false,
      currentlyPlaying: {},
    });
  };

  setPlayer = function instantiatePlayerInAppState(player) {
    this.setState({ player });
  };

  render() {
    const { error, errorText, basePath } = this.state;
    return error ? (
      <p>{String(errorText)}</p>
    ) : (
      <Router basename={basePath}>
        <Routes
          {...this.state}
          showModal={this.showModal}
          hideModal={this.hideModal}
          playStation={this.playStation}
          pauseStation={this.pauseStation}
          closePlayer={this.closePlayer}
          setPlayer={this.setPlayer}
        />
      </Router>
    );
  }
}

App.propTypes = {
  firebase: shape().isRequired,
};

export default withFirebase(App);
